import type { TextLoadInput } from '@/shared/api/resources';

/**
 * Le o arquivo do pacote de textos da seguradora (P-MIN-5). O formato e o da API:
 * { label, items }.
 */
export function lerPacote(texto: string): TextLoadInput {
  let dados: unknown;
  try {
    dados = JSON.parse(texto);
  } catch {
    throw new Error('O arquivo nao e um JSON valido.');
  }
  if (
    typeof dados !== 'object' ||
    dados === null ||
    !Array.isArray((dados as TextLoadInput).items)
  ) {
    throw new Error('O pacote precisa ter a lista "items".');
  }
  const pacote = dados as TextLoadInput;
  if (pacote.items.length === 0) {
    throw new Error('O pacote nao tem itens.');
  }
  const lido = {
    label: typeof pacote.label === 'string' ? pacote.label : '',
    items: pacote.items,
  };
  // A API aceita ate 1 MB por corpo, e o pacote vai inteiro numa carga so. O pacote
  // maior seria recusado sem dizer o motivo; aqui ele e recusado antes, com o tamanho
  // e o caminho: partir em pacotes menores (R5-B17 da revisao 5).
  const tamanho = new TextEncoder().encode(JSON.stringify(lido)).length;
  if (tamanho > TAMANHO_MAXIMO_DO_PACOTE) {
    throw new Error(
      `O pacote tem ${megabytes(tamanho)} MB, e a carga aceita ate 1 MB de cada vez. ` +
        'Divida o arquivo em pacotes menores (por exemplo, por modalidade) e carregue um de cada vez.',
    );
  }
  return lido;
}

/**
 * O limite do corpo da API (1 MB), menos a folga da descricao, que a tela deixa
 * trocar antes de carregar.
 */
export const TAMANHO_MAXIMO_DO_PACOTE = 1024 * 1024 - 1024;

function megabytes(bytes: number): string {
  return (bytes / (1024 * 1024)).toFixed(1).replace('.', ',');
}
